import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Products.scss';
import messages from '../messages';

class Products extends React.Component {
  static propTypes = {
    products: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    ).isRequired,
    heading: PropTypes.element,
    className: PropTypes.string,
  };

  static defaultProps = {
    heading: <FormattedMessage {...messages.ourProducts} />,
    className: '',
  };

  constructor(props) {
    super(props);

    this.renderProducts = this.renderProducts.bind(this);
    this.renderProductRow = this.renderProductRow.bind(this);
  }

  renderProducts() {
    // group into pairs of three
    // pairs get rendered in a new row each
    const { products } = this.props;
    const productRows = products.reduce((result, value, index, array) => {
      if (index % 3 === 0) result.push(array.slice(index, index + 3));
      return result;
    }, []);

    return productRows.map(this.renderProductRow);
  }

  renderProductRow(productRow, index) {
    const className = [s.products, this.props.className].join(' ');

    const dataset1 = productRow[0];
    const dataset2 = productRow[1];
    const dataset3 = productRow[2];

    const content = product => {
      const waltzingTitleStyle = product.waltzingTitle
        ? {}
        : { visibility: 'hidden' };
      return (
        <div key={product.name} className={`col-sm-4 col-xs-12 ${s.product}`}>
          <img
            src={product.logo}
            alt={product.name}
            style={{ height: '80px', width: '80px' }}
            className="img-responsive"
          />

          <h3 className="teal" style={waltzingTitleStyle}>
            Waltzing
          </h3>

          <h3>
            {product.name}
          </h3>
          <h4>
            {product.heading}
          </h4>
          <p style={{ minHeight: '70px' }}>
            {product.description}
          </p>
          {product.link &&
            <a
              href={product.link}
              target={`${product.openNewPage ? '_blank' : '_self'}`}
              rel="noopener noreferrer"
              className="btn btn-teal btn--small"
            >
              {product.linkLabel}
            </a>}
        </div>
      );
    };
    return (
      <div key={`product-row-${index}`} className={`row ${className}`}>
        {content(dataset1)}
        {dataset2 && content(dataset2) /* second value of row can be empty */}
        {dataset3 && content(dataset3) /* third value of row can be empty */}
      </div>
    );
  }

  render() {
    const { heading } = this.props;

    return (
      <div>
        <h2>
          <FormattedMessage {...messages.getSmart} />
        </h2>
        <h3>
          {heading}
        </h3>
        {this.renderProducts()}
      </div>
    );
  }
}

export default withStyles(s)(Products);



// WEBPACK FOOTER //
// ./src/routes/home/products/Products.js